<template>
  <div>
    <h4 v-html="$t(`tos:${subtitleTag}`)"></h4>
    <div class="content" >
      <p v-for="paragraph in paragraphs" :key="paragraph" v-html="$t(`tos:${paragraph}`)"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfServiceParagraph',
  props: {
    subtitleTag: String,
    paragraphs: Array
  }
}
</script>

<style scoped>
.content {
  padding-top: 0.5em;
  padding-bottom: 0.75em;
}
</style>
